import { IPasswordPolicy } from "../../../models/PwdPolicy";
import { ISecurityQuestion } from "../../ProfileManagement/SecurityQuestionsManagement/module/constants";
import { IDataPostLogin, IDomains } from "./constants";

export const actionTypes = {
  SET_FIRST_ACCESS: "SET_FIRST_ACCESS",
  SET_OLD_PASSWORD: "SET_OLD_PASSWORD",
  GENERATE_LOGIN_OTP: "GENERATE_LOGIN_OTP",
  GENERATE_LOGIN_OTP_SUCCESS: "GENERATE_LOGIN_OTP_SUCCESS",
  GENERATE_LOGIN_OTP_FAILURE: "GENERATE_LOGIN_OTP_FAILURE",
  CHANGE_FIRST_PWD: "CHANGE_FIRST_PWD",
  CHANGE_FIRST_PWD_SUCCESS: "CHANGE_FIRST_PWD_SUCCESS",
  CHANGE_FIRST_PWD_FAILURE: "CHANGE_FIRST_PWD_FAILURE",
  VERIFY_LOGIN_OTP: "VERIFY_LOGIN_OTP",
  VERIFY_LOGIN_OTP_SUCCESS: "VERIFY_LOGIN_OTP_SUCCESS",
  VERIFY_LOGIN_OTP_FAILURE: "VERIFY_LOGIN_OTP_FAILURE",
  GET_DOMAINS: "GET_DOMAINS",
  GET_DOMAINS_SUCCESS: "GET_DOMAINS_SUCCESS",
  GET_DOMAINS_FAILURE: "GET_DOMAINS_FAILURE",
  GET_QUESTIONS_LOGIN: "GET_QUESTIONS_LOGIN",
  GET_QUESTIONS_LOGIN_SUCCESS: "GET_QUESTIONS_LOGIN_SUCCESS",
  GET_QUESTIONS_LOGIN_FAILURE: "GET_QUESTIONS_LOGIN_FAILURE",
  DISPATCH_LOGIN_ANSWER: "DISPATCH_LOGIN_ANSWER",
  SET_USER: "SET_USER",
  SET_OTP: "SET_OTP",
  RESET_LOGIN_STATE: "RESET_LOGIN_STATE",
  POST_LOGIN_ANSWER: "POST_LOGIN_ANSWER",
  POST_LOGIN_ANSWER_SUCCESS: "POST_LOGIN_ANSWER_SUCCESS",
  POST_LOGIN_ANSWER_FAILURE: "POST_LOGIN_ANSWER_FAILURE",
  POST_LOGIN_OTP: "POST_LOGIN_OTP",
  POST_LOGIN_OTP_SUCCESS: "POST_LOGIN_OTP_SUCCESS",
  POST_LOGIN_OTP_FAILURE: "POST_LOGIN_OTP_FAILURE",
  GET_PASSWORD_POLICY: "GET_PASSWORD_POLICY",
  GET_PASSWORD_POLICY_SUCCESS: "GET_PASSWORD_POLICY_SUCCESS",
  GET_PASSWORD_POLICY_FAILURE: "GET_PASSWORD_POLICY_FAILURE",
  POST_PASSWORD: "POST_PASSWORD",
  POST_PASSWORD_SUCCESS: "POST_PASSWORD_SUCCESS",
  POST_PASSWORD_FAILURE: "POST_PASSWORD_FAILURE",
  RESET_MODAL_OTP_STATE: "RESET_MODAL_OTP_STATE",
  SET_TEMP_TOKEN: "SET_TEMP_TOKEN",
};

export const setFirstAccessAction = (payload: any) => ({
  type: actionTypes.SET_FIRST_ACCESS,
  payload,
});

export const setOldPasswordAction = (payload: any) => ({
  type: actionTypes.SET_OLD_PASSWORD,
  payload,
});

export const setTempTokenAction = (payload: any) => ({
  type: actionTypes.SET_TEMP_TOKEN,
  payload,
});

export const generateLoginOtpRequest = (payload: any) => ({
  type: actionTypes.GENERATE_LOGIN_OTP,
  payload,
});

export const generateLoginOtpRequestSuccess = (payload: any) => ({
  type: actionTypes.GENERATE_LOGIN_OTP_SUCCESS,
  payload,
});

export const generateLoginOtpRequestFailure = (error: any) => ({
  type: actionTypes.GENERATE_LOGIN_OTP_FAILURE,
  error,
});

export const verifyLoginOtpRequest = (payload: any) => ({
  type: actionTypes.VERIFY_LOGIN_OTP,
  payload,
});

export const verifyLoginOtpRequestSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_LOGIN_OTP_SUCCESS,
  payload,
});

export const verifyLoginOtpRequestFailure = (error: any) => ({
  type: actionTypes.VERIFY_LOGIN_OTP_FAILURE,
  error,
});

export const getDomains = () => ({
  type: actionTypes.GET_DOMAINS,
});

export const getDomainsSuccess = (domains: IDomains[]) => ({
  type: actionTypes.GET_DOMAINS_SUCCESS,
  payload: domains,
});

export const getDomainsFailure = (err: Error) => ({
  type: actionTypes.GET_DOMAINS_FAILURE,
  err,
});

export const setUser = (user: string) => ({
  type: actionTypes.SET_USER,
  payload: user,
});

export const setOTP = (otp: string) => ({
  type: actionTypes.SET_OTP,
  payload: otp,
});

export const getQuestionsLogin = (user: string) => ({
  type: actionTypes.GET_QUESTIONS_LOGIN,
  payload: user,
});

export const getQuestionsLoginSuccess = (questions: ISecurityQuestion[]) => ({
  type: actionTypes.GET_QUESTIONS_LOGIN_SUCCESS,
  payload: questions,
});

export const getQuestionsLoginFailure = (err: Error) => ({
  type: actionTypes.GET_QUESTIONS_LOGIN_FAILURE,
  err,
});

export const dispatchLoginAnswer = (answer: string, index: number) => ({
  type: actionTypes.DISPATCH_LOGIN_ANSWER,
  payload: { answer, index },
});

export const resetState = () => ({
  type: actionTypes.RESET_LOGIN_STATE,
});

export const postLoginAnswerAction = (payload: IDataPostLogin) => ({
  type: actionTypes.POST_LOGIN_ANSWER,
  payload: payload,
});

export const postLoginAnswerSuccess = (response: {
  responseId: number;
  responseCode: string;
}) => ({
  type: actionTypes.POST_LOGIN_ANSWER_SUCCESS,
  payload: response,
});

export const postLoginAnswerFailure = (err: Error) => ({
  type: actionTypes.POST_LOGIN_ANSWER_FAILURE,
  err,
});

export const postOTPAction = (body: IDataPostLogin) => ({
  type: actionTypes.POST_LOGIN_OTP,
  payload: body,
});

export const postOTPSuccess = (response: {
  responseId: number;
  responseCode: string;
}) => ({
  type: actionTypes.POST_LOGIN_OTP_SUCCESS,
  payload: response,
});

export const postOTPFailure = (err: Error) => ({
  type: actionTypes.POST_LOGIN_OTP_FAILURE,
  err,
});

export const resetModalOtpStateAction = () => ({
  type: actionTypes.RESET_MODAL_OTP_STATE,
});

export const getPasswordPolicyAction = () => ({
  type: actionTypes.GET_PASSWORD_POLICY,
});

export const getPasswordPolicySuccess = (response: IPasswordPolicy) => ({
  type: actionTypes.GET_PASSWORD_POLICY_SUCCESS,
  payload: response,
});

export const getPasswordPolicyFailure = (err: Error) => ({
  type: actionTypes.GET_PASSWORD_POLICY_FAILURE,
  err,
});

export const postPasswordAction = (token: string, data: string) => ({
  type: actionTypes.POST_PASSWORD,
  payload: { token, data },
});

export const postPasswordSuccess = () => ({
  type: actionTypes.POST_PASSWORD_SUCCESS,
});

export const postPasswordFailure = (err: Error) => ({
  type: actionTypes.POST_PASSWORD_FAILURE,
  err,
});

export const changeFirstPasswordAction = (payload: any) => ({
  type: actionTypes.CHANGE_FIRST_PWD,
  payload,
});

export const changeFirstPasswordSuccess = () => ({
  type: actionTypes.CHANGE_FIRST_PWD_SUCCESS,
});

export const changeFirstPasswordFailure = (err: Error) => ({
  type: actionTypes.CHANGE_FIRST_PWD_FAILURE,
  err,
});
